import { BlockStack, Text, Icon, InlineGrid, TextField, Button, Link } from '@shopify/polaris';
import { CheckCircleIcon } from '@shopify/polaris-icons';
import { StyledFinishStep } from './styled';
import { CopyIcon } from '@/icons';
import { useSelector } from 'react-redux';
import { tokenSelector } from '@/redux/features/auth.slice';
import { LINK } from '@/constants';
import useTrackingPageUrl from '@/hooks/useTrackingPageUrl';
import { FINISHED_STEPS, getExternalActions } from './config';

const FinishStep = () => {
  const { shop } = useSelector(tokenSelector);

  const { url: storefrontLink } = useTrackingPageUrl();

  return (
    <StyledFinishStep>
      <BlockStack gap="400">
        <div className="finish-step-container">
          {FINISHED_STEPS.map((text) => (
            <div key={text} className="finish-step-item">
              <div className="icon-wrapper">
                <Icon source={CheckCircleIcon} tone="success" />
              </div>
              <Text as="span" variant="bodyMd">
                {text}
              </Text>
            </div>
          ))}
        </div>
        <Text as="p" variant="bodyLg" alignment="center">
          You can add <strong>Tracking page URL</strong> to store navigation or add <strong>Order lookup widget</strong>
        </Text>
      </BlockStack>

      <div className="finish-step-content">
        <InlineGrid columns={['oneHalf', 'oneHalf']} gap="400" alignItems="center">
          <img src={`${process.env.REACT_APP_S3_ASSETS_BASE_URL}/onboarding/20250507-144935.png`} alt="finish-step" />

          <BlockStack gap="400">
            <BlockStack gap="100">
              <TextField
                autoComplete="off"
                label="URL"
                labelHidden
                value={storefrontLink}
                readOnly
                suffix={<CopyIcon copiedText={storefrontLink} />}
              />

              <Text variant="bodyMd" as="p">
                Go to{' '}
                <Link monochrome url={LINK.SHOPIFY_MENU(shop)}>
                  Store menus
                </Link>
                , choose a menu and add this link as a menu item.
              </Text>
            </BlockStack>

            {getExternalActions(storefrontLink).map(({ icon, text, onClick, url }) => (
              <Button key={text} icon={icon} variant="plain" textAlign="left" external onClick={onClick} url={url}>
                {text}
              </Button>
            ))}
          </BlockStack>
        </InlineGrid>
      </div>
    </StyledFinishStep>
  );
};

export default FinishStep;
